<template>
  <div class="modal-card addUser">
    <div class="modal-card-head">
      <div class="modal-card-title">External legal representative access request</div>
    </div>
    <div class="modal-card-body">
      <div class="columns">
        <div class="column">

          <b-field label="First name">
            <b-input placeholder="First Name" type="text" v-model="user.FirstName"></b-input>
          </b-field>

          <b-field label="Last name">
            <b-input placeholder="Last Name" type="text" v-model="user.LastName"></b-input>
          </b-field>

          <b-field label="Email">
            <b-input placeholder="Email" type="email" v-model="user.Email"></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Expires on">
            <b-datepicker v-model="user.Expires"></b-datepicker>
          </b-field>

          <b-field label="Organization">
            <b-input placeholder="Organization's Name" type="text" v-model="user.Organization"></b-input>
          </b-field>

          <b-field label="Organization Address">
            <b-input placeholder="Organization's Address" type="text" v-model="user.OrganizationAddress"></b-input>
          </b-field>
        </div>
      </div>
    </div>
    <div class="modal-card-foot">
      <b-button class="yellow-button" @click="$parent.close()">Close</b-button>
      <b-button class="is-primary" @click="create">Submit</b-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        user: {},
        roles: []
      }
    },
    methods: {
      create() {
        if (this.user.OrganizationAddress && this.user.Organization && this.user.FirstName && this.user.LastName && this.user.Expires && this.user.Email) {
          this.user.Name = this.user.FirstName + " " + this.user.LastName;
          this.user.Expires = new Date(this.user.Expires);
          this.$http.post("api/request/external/create", this.user)
            .then(resp => {
              this.$buefy.toast.open(resp.data);
              this.$parent.close();
              this.$emit("refresh");
            }).catch(e => {
              console.error(e)
            });
        }
        else {
          this.$buefy.toast.open("You must fill out all fields.");
        }
      },
    }
  }
</script>
